import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationService } from '@services/api-calls/application.service';
import { ErrorHandlingService } from '@services/error-handling.service';
import { GiactTestToggleService } from '@services/testing/giact-test-toggle.service';
import { GiactOutcomeEnum, GiactStatusEnum } from 'app/enums/form/form.enum';
import { catchError, EMPTY, Observable, of, throwError } from 'rxjs';

const API_URL = environment.apiUrl;

export interface GiactVerificationResponse {
    status: number;
    outcome: string;
}

const MOCK_SUCCESS_RESPONSE: GiactVerificationResponse = {
    status: GiactStatusEnum.SUCCESS,
    outcome: GiactOutcomeEnum.VERIFIED,
};

const MOCK_FAIL_RESPONSE: GiactVerificationResponse = {
    status: GiactStatusEnum.FAILED,
    outcome: GiactOutcomeEnum.VERIFICATION_FAILED,
};

@Injectable({
    providedIn: 'root',
})
export class GiactService {
    constructor(
        private http: HttpClient,
        private applicationService: ApplicationService,
        private errorHandlingService: ErrorHandlingService,
        private giactTestToggleService: GiactTestToggleService,
        private translateService: TranslateService,
    ) {}

    verifyIdentity(appId: number): Observable<GiactVerificationResponse> {
        if (this.giactTestToggleService.isMockSuccess()) {
            return of(MOCK_SUCCESS_RESPONSE);
        }

        if (this.giactTestToggleService.isMockFail()) {
            return of(MOCK_FAIL_RESPONSE);
        }

        // Check test toggle - simulate failure if enabled
        if (this.giactTestToggleService.isMockError()) {
            return throwError(() => new Error(this.translateService.instant('ERRORS.GIACT_VERIFICATION_FAILED')));
        }

        const url = `${API_URL}/applications/${appId}/giact`;

        return this.http.post<GiactVerificationResponse>(url, {}).pipe(catchError(() => EMPTY));
    }
}
